import i18n from '@/i18n'
import ReportHeading from '@/Utils/report-head'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFontsBn from 'pdfmake/build/vfs_fonts_bn'
import pdfFontsEn from 'pdfmake/build/vfs_fonts_en'
import { dateFormat } from '@/Utils/fliter'

function mobileNumber (value) {
  try {
        if (typeof value !== 'undefined' && value) {
           if (i18n.locale === 'bn') {
               return '০' + i18n.n(value, { useGrouping: false })
           } else {
            return '0' + i18n.n(value, { useGrouping: false })
        }
        }
  } catch (e) {
        return value
    }
}

function getImage (data, vm) {
  if (parseInt(data.is_disabled_applicant) === 1) {
    if (data.patientImage.data) {
        return [
          { text: vm.$t('externalUser.disabled_person_photo'), style: 'th', alignment: 'left' },
          { image: 'data:image/png;base64,' + data.patientImage.data, height: 60, width: 60, style: 'img' },
          {},
          {}
        ]
    } else {
      return [{}, {}, {}, {}]
    }
  } else {
    if (data.patientImage.data && data.applicantImage.data) {
      return [
        { text: vm.$t('externalUser.disabled_person_photo'), style: 'th', alignment: 'left' },
        { image: 'data:image/png;base64,' + data.patientImage.data, height: 60, width: 60, style: 'img' },
        { text: vm.$t('externalUser.applicant_attachment'), style: 'th', alignment: 'left' },
        { image: 'data:image/png;base64,' + data.applicantImage.data, height: 60, width: 60, style: 'img' }
      ]
    } else {
      return [{}, {}, {}, {}]
    }
  }
}

function medicalAssistAddressRow (data, vm) {
  if (data.pr_city_corporation) {
    return [
      { text: vm.$t('org_pro.ward'), style: 'th', alignment: 'left' },
      { text: data.pr_ward, colSpan: 3, style: 'th', alignment: 'left' },
      {},
      {}
    ]
  } else {
    return [
      { text: data.pr_paurasabha ? vm.$t('org_pro.pauroshoba') : vm.$t('org_pro_union.union'), style: 'th', alignment: 'left' },
      { text: data.pr_paurasabha ? data.pr_paurasabha : data.pr_union, style: 'th', alignment: 'left' },
      { text: vm.$t('org_pro.ward'), style: 'th', alignment: 'left' },
      { text: data.pr_ward, style: 'th', alignment: 'left' }
    ]
  }
}

function medicalAssistAddressRow2 (data, vm) {
  if (data.pm_city_corporation) {
    return [
      { text: vm.$t('org_pro.ward'), style: 'th', alignment: 'left' },
      { text: data.pm_ward, colSpan: 3, style: 'th', alignment: 'left' },
      {},
      {}
    ]
  } else {
    return [
      { text: data.pm_paurasabha ? vm.$t('org_pro.pauroshoba') : vm.$t('org_pro_union.union'), style: 'th', alignment: 'left' },
      { text: data.pm_paurasabha ? data.pm_paurasabha : data.pm_union, style: 'th', alignment: 'left' },
      { text: vm.$t('org_pro.ward'), style: 'th', alignment: 'left' },
      { text: data.pm_ward, style: 'th', alignment: 'left' }
    ]
  }
}

function getOfficeOrApplicationTo (data, vm) {
  if (data.application_to_name && data.office_type_name) {
    return [
      { text: vm.$t('externalUser.application_to'), style: 'th', alignment: 'left' },
      { text: data.application_to_name, style: 'th' },
      { text: vm.$t('externalUser.office_name'), style: 'th', alignment: 'left' },
      { text: data.office_type_name, style: 'th' }
    ]
  } else if (!data.application_to_name && data.office_type_name) {
    return [
      { text: vm.$t('externalUser.office_name'), style: 'th', alignment: 'left' },
      { text: data.office_type_name, style: 'th', colSpan: 3 },
      {},
      {}
    ]
  } else if (data.application_to_name && !data.office_type_name) {
    return [
      { text: vm.$t('externalUser.application_to'), style: 'th', alignment: 'left' },
      { text: data.application_to_name, style: 'th', colSpan: 3 },
      {},
      {}
    ]
  } else {
    return [
      { text: '', colSpan: 4, display: false },
      {},
      {},
      {}
    ]
  }
}

function getDivDistInfo (data, vm) {
  if (data.division && data.district) {
    return [
      { text: vm.$t('hospital_public_panel.division'), style: 'th', alignment: 'left' },
      { text: data.division, style: 'th', alignment: 'left' },
      { text: vm.$t('hospital_public_panel.district'), style: 'th', alignment: 'left' },
      { text: data.district, style: 'th', alignment: 'left' }
    ]
  } else if (!data.division && data.district) {
    return [
      { text: vm.$t('hospital_public_panel.district'), style: 'th', alignment: 'left' },
      { text: data.district, style: 'th', colSpan: 3, alignment: 'left' },
      {},
      {}
    ]
  } else if (data.division && !data.district) {
    return [
      { text: vm.$t('hospital_public_panel.division'), style: 'th', alignment: 'left' },
      { text: data.division, style: 'th', colSpan: 3, alignment: 'left' }
    ]
  } else {
    return [
      { text: '', colSpan: 4, display: false },
      {},
      {},
      {}
    ]
  }
}
function getBase64ImageFromURL (url) {
  return new Promise((resolve, reject) => {
    var img = new Image()
    img.setAttribute('crossOrigin', 'anonymous')

    img.onload = () => {
      var canvas = document.createElement('canvas')
      canvas.width = img.width
      canvas.height = img.height

      var ctx = canvas.getContext('2d')
      ctx.drawImage(img, 0, 0)

      var dataURL = canvas.toDataURL('image/png')

      resolve(dataURL)
    }

    img.onerror = error => {
      reject(error)
    }

    img.src = url
  })
}

const exportPdfDetails = async (baseUrl, uri = '/report-heading/detail', orgId, reportTitle, data, vm) => {
    try {
      // Loading
      vm.modalLoader = true

      // Translation
      if (i18n.locale === 'bn') {
        pdfMake.vfs = pdfFontsBn.pdfMake.vfs
      } else {
          pdfMake.vfs = pdfFontsEn.pdfMake.vfs
      }

      // API Call
      const reportHeadData = await ReportHeading.getReportHead(baseUrl, uri, orgId)

      // PDF
      const pdfContent = []

      //
      if (data.tracking_no === 8) {
        pdfContent.push(
          {
            table: {
              style: 'tableData',
              headerRows: 0,
              widths: ['25%', '50%', '25%'],
              body: [
                [
                  {},
                  { image: reportHeadData.reportHeadColumn[0].image, height: 50, width: 50, alignment: 'center' },
                  {}
                ],
                [
                  { },
                  { text: vm.$t('production_store.govt_info'), style: 'govt_info', alignment: 'center' },
                  { }
                ],
                [
                  {},
                  { text: vm.currentLocale === 'en' ? 'Ministry Of Social Welfare' : 'সমাজকল্যাণ মন্ত্রণালয়', style: 'address', alignment: 'center' },
                  {}
                ],
                [
                  {},
                  { text: reportHeadData.orgName, style: 'header2', alignment: 'center' },
                  {}
                ],
                [
                  {},
                  { text: reportHeadData.address, style: 'address', alignment: 'center' },
                  {}
                ],
                [
                  {},
                  { text: reportTitle, style: 'address2', alignment: 'center' },
                  {}
                ]
              ]
            },
            layout: {
              hLineWidth: function (i, node) {
                return 0
              },
              vLineWidth: function (i, node) {
                return 0
              }
            }
          }
        )
      } else if (data.tracking_no === 9) {
        pdfContent.push(
          {
            table: {
              style: 'tableData',
              headerRows: 0,
              widths: ['25%', '50%', '25%'],
              body: [
                [
                  {},
                  { image: reportHeadData.reportHeadColumn[0].image, height: 50, width: 50, alignment: 'center' },
                  {}
                ],
                [
                  { },
                  { text: vm.$t('production_store.govt_info'), style: 'govt_info', alignment: 'center' },
                  { }
                ],
                [
                  {},
                  { text: vm.currentLocale === 'en' ? 'Ministry Of Social Welfare' : 'সমাজকল্যাণ মন্ত্রণালয়', style: 'address', alignment: 'center' },
                  {}
                ],
                [
                  {},
                  { text: reportHeadData.orgName, style: 'header2', alignment: 'center' },
                  {}
                ],
                [
                  {},
                  { text: reportHeadData.address, style: 'address', alignment: 'center' },
                  {}
                ],
                [
                  {},
                  { text: reportTitle, style: 'address2', alignment: 'center' },
                  {}
                ]
              ]
            },
            layout: {
              hLineWidth: function (i, node) {
                return 0
              },
              vLineWidth: function (i, node) {
                return 0
              }
            }
          }
        )
      } else if (data.tracking_no === 10) {
        pdfContent.push(
          {
            table: {
              style: 'tableData',
              headerRows: 0,
              widths: ['25%', '50%', '25%'],
              body: [
                [
                  {},
                  { image: reportHeadData.reportHeadColumn[0].image, height: 50, width: 50, alignment: 'center' },
                  {}
                ],
                [
                  { },
                  { text: vm.$t('production_store.govt_info'), style: 'govt_info', alignment: 'center' },
                  { }
                ],
                [
                  {},
                  { text: vm.currentLocale === 'en' ? 'Ministry Of Social Welfare' : 'সমাজকল্যাণ মন্ত্রণালয়', style: 'address', alignment: 'center' },
                  {}
                ],
                [
                  {},
                  { text: reportHeadData.orgName, style: 'header2', alignment: 'center' },
                  {}
                ],
                [
                  {},
                  { text: reportHeadData.address, style: 'address', alignment: 'center' },
                  {}
                ],
                [
                  {},
                  { text: reportTitle, style: 'address2', alignment: 'center' },
                  {}
                ]
              ]
            },
            layout: {
              hLineWidth: function (i, node) {
                return 0
              },
              vLineWidth: function (i, node) {
                return 0
              }
            }
          }
        )
      } else {
        pdfContent.push(
          {
            table: {
              style: 'tableData',
              headerRows: 0,
              widths: ['25%', '50%', '25%'],
              body: [
                [
                  { image: reportHeadData.reportHeadColumn[0].image, height: 50, width: 50, alignment: 'center', rowSpan: 5 },
                  { text: vm.$t('production_store.govt_info'), style: 'govt_info', alignment: 'center' },
                  { image: reportHeadData.reportHeadColumn[1].image, height: 50, width: 50, alignment: 'center', rowSpan: 5 }
                ],
                [
                  {},
                  { text: vm.currentLocale === 'en' ? 'Ministry Of Social Welfare' : 'সমাজকল্যাণ মন্ত্রণালয়', style: 'address', alignment: 'center' },
                  {}
                ],
                [
                  {},
                  { text: reportHeadData.orgName, style: 'header2', alignment: 'center' },
                  {}
                ],
                [
                  {},
                  { text: reportHeadData.address, style: 'address', alignment: 'center' },
                  {}
                ],
                [
                  {},
                  { text: reportTitle, style: 'address2', alignment: 'center' },
                  {}
                ]
              ]
            },
            layout: {
              hLineWidth: function (i, node) {
                return 0
              },
              vLineWidth: function (i, node) {
                return 0
              }
            }
          }
        )
      }
      /**
       * General Information
       * DAUD
       */
      const generalInformation = [
        [
          { text: vm.$t('externalUser.general_information'), colSpan: 4, style: 'th2', alignment: 'center', bold: true },
          {},
          {},
          {}
        ],
        [
          {
            text: data.tracking_no === 10
                    ? vm.$t('externalUser.coordination_council_name')
                    : (data.tracking_no === 9)
                        ? vm.$t('externalUser.offender_correction_name')
                          : (data.tracking_no === 8
                            ? vm.$t('grant_process.patient_welfare')
                            : vm.$t('grant_process.app_ins_name')),
            style: 'th',
            alignment: 'left'
          },
          { text: vm.currentLocale === 'en' ? data.applicant_name : data.applicant_name_bn, style: 'th', alignment: 'left' },
          { text: data.tracking_no !== 10 && data.tracking_no !== 9 && data.tracking_no !== 8 ? vm.$t('externalUser.organization') : '', style: 'th', alignment: 'left' },
          { text: data.tracking_no !== 10 && data.tracking_no !== 9 && data.tracking_no !== 8 ? data.org : '', style: 'th', alignment: 'left' }
        ],
        data.tracking_no !== 10 && data.tracking_no !== 9 && data.tracking_no !== 8 ? getDivDistInfo(data, vm) : [
          { },
          { },
          { },
          { }
        ]
      ]

      const presentAddress = [
        [
          {
            text: data.tracking_no === 10
              ? vm.$t('externalUser.ucd_development_x_present_address')
              : data.tracking_no === 9
                ? vm.$t('externalUser.offender_correction_address')
                : data.tracking_no === 8
                  ? vm.$t('externalUser.patient_info_and_address')
                  : vm.$t('globalTrans.present_address'),
            colSpan: 4,
            style: 'th2',
            alignment: 'center',
            bold: true
          },
          {},
          {},
          {}
        ]
      ]

      const paemanentAddress = [
        [
          { text: vm.$t('globalTrans.permanent_address'), colSpan: 4, style: 'th2', alignment: 'center', bold: true },
          {},
          {},
          {}
        ]
      ]

      if (data.tracking_no === 1) {
        /** Rehabilitation activities for burn victims */
        generalInformation.push(
          [
            { text: vm.$t('externalUser.father_name'), style: 'th', alignment: 'left' },
            { text: vm.currentLocale === 'en' ? data.rehabitation.father_name : data.rehabitation.father_name_bn, style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.application_type'), style: 'th', alignment: 'left' },
            { text: data.application_type_name, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('grant_config.hospital_category'), style: 'th', alignment: 'left' },
            { text: data.hospital_name, style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.mobile_no'), style: 'th', alignment: 'left' },
            { text: mobileNumber(data.rehabitation.mobile_no), style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('externalUser.nid_no'), style: 'th', alignment: 'left' },
            { text: mobileNumber(data.rehabitation.nid_no), style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.birth_reg_no'), style: 'th', alignment: 'left' },
            { text: vm.$n(data.rehabitation.birth_reg_no, { useGrouping: false }), style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('globalUserData.gender'), style: 'th', alignment: 'left' },
            { text: data.gender_name, style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.office_name'), style: 'th', alignment: 'left' },
            { text: data.office_type_name, style: 'th', alignment: 'left' }
          ]
        )
      } else if (data.tracking_no === 2) {
        /** Private orphanage capitation grant */
        // let typeData = ''
        // if (data.orphanage.institute.ins_type === 1) {
        //   typeData = vm.$t('grant_process.boy')
        // } else if (data.orphanage.institute.ins_type === 2) {
        //   typeData = vm.$t('grant_process.girl')
        // } else {
        //   typeData = vm.$t('globalTrans.other')
        // }
        generalInformation.push(
          [
            { text: vm.$t('externalUser.office_name'), style: 'th', alignment: 'left' },
            { text: data.office_type_name, style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.institute_type'), style: 'th', alignment: 'left' },
            {
              text: data.orphanage.institute
                ? parseInt(data.orphanage.institute.ins_type) === 1
                  ? vm.currentLocale === 'en' ? 'Boy' : 'ছেলে'
                  : parseInt(data.orphanage.institute.ins_type) === 2
                    ? vm.currentLocale === 'en' ? 'Girl' : 'মেয়ে'
                    : parseInt(data.orphanage.institute.ins_type) === 3
                      ? vm.currentLocale === 'en' ? 'Both (Boy & Girl)' : 'উভয়ই (ছেলে ও মেয়ে)'
                      : ''
                : '',
              style: 'th',
              alignment: 'left'
            }
          ],
          [
            { text: vm.$t('externalUser.institution_name'), style: 'th', alignment: 'left' },
            { text: vm.currentLocale === 'en' ? data.orphanage.institute.ins_name : data.orphanage.institute.ins_name_bn, style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.institution_registration_no'), style: 'th', alignment: 'left' },
            { text: data.orphanage.institute.others.reg_no, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('externalUser.registration_date'), style: 'th', alignment: 'left' },
            { text: vm.$d(new Date(data.orphanage.institute.others.reg_date)), style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.current_residence'), style: 'th', alignment: 'left' },
            { text: vm.$n(data.orphanage.current_residence), style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('inspection.prev_fiscal_capital'), style: 'th', alignment: 'left' },
            { text: vm.$n(data.orphanage.last_cap_granted_residence), style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.proposed_cap_granted_residence'), style: 'th', alignment: 'left' },
            { text: vm.$n(data.orphanage.proposed_cap_granted_residence), style: 'th', alignment: 'left' }
          ]
          // [
          //   { text: vm.$t('externalUser.approved_qty'), style: 'th', alignment: 'left' },
          //   { text: vm.$n(data.orphanage.institute.others.approve_quantity), style: 'th', alignment: 'left' },
          //   { },
          //   { }
          // ]
        )
      } else if (data.tracking_no === 3) {
        /** medical assistance to persons with disabilities */
        generalInformation.push(
          getImage(data.med_assistance, vm),
          [
            { text: vm.$t('externalUser.father_name'), style: 'th', alignment: 'left' },
            { text: vm.currentLocale === 'en' ? data.med_assistance.father_name : data.med_assistance.father_name_bn, style: 'th' },
            { text: vm.$t('externalUser.mother_name'), style: 'th', alignment: 'left' },
            { text: vm.currentLocale === 'en' ? data.med_assistance.mother_name : data.med_assistance.mother_name_bn, style: 'th' }
          ],
          [
            { text: vm.$t('child_admission_management.legal_guardian'), style: 'th', alignment: 'left' },
            { text: vm.currentLocale === 'en' ? data.med_assistance.legal_guardian_en : data.med_assistance.legal_guardian_bn, style: 'th' },
            { text: vm.$t('externalUser.guardian_yearly_avg_income'), style: 'th', alignment: 'left' },
            { text: vm.$n(data.med_assistance.guardian_yearly_income), style: 'th' }
          ],
          [
            { text: vm.$t('externalUser.reg_no'), style: 'th', alignment: 'left' },
            { text: vm.$n(data.med_assistance.reg_no, { useGrouping: false }), style: 'th' },
            { text: vm.$t('externalUser.dob'), style: 'th', alignment: 'left' },
            { text: vm.$d(new Date(data.med_assistance.date_of_birth)), style: 'th' }
          ],
          [
            { text: vm.$t('externalUser.mobile_no'), style: 'th', alignment: 'left' },
            { text: mobileNumber(data.med_assistance.mobile_no), style: 'th' },
            { text: vm.$t('globalUserData.gender'), style: 'th', alignment: 'left' },
            { text: data.gender_name, style: 'th' }
          ],
          [
            { text: vm.$t('externalUser.age'), style: 'th', alignment: 'left' },
            { text: vm.$n(data.med_assistance.age), style: 'th' },
            { text: data.med_assistance.nid_no ? vm.$t('externalUser.nid_no') : vm.$t('externalUser.brs_no'), style: 'th', alignment: 'left' },
            { text: data.med_assistance.nid_no ? vm.$n(data.med_assistance.nid_no, { useGrouping: false }) : vm.$n(data.med_assistance.birth_reg_no, { useGrouping: false }), style: 'th' }
          ],
          [
            { text: vm.$t('externalUser.disability_type'), style: 'th', alignment: 'left' },
            { text: data.disability_type, colSpan: 3, style: 'th' },
            {},
            {}
          ],
          getOfficeOrApplicationTo(data, vm),
          [
            { text: vm.$t('external_sidebar.circular'), style: 'th', alignment: 'left' },
            { text: data.circular_name ? data.circular_name : '', colSpan: 3, style: 'th' },
            { },
            { }
          ]
        )
        presentAddress.push(
          [
            { text: vm.$t('org_pro.area_type'), style: 'th', alignment: 'left' },
            { text: data.pr_area_type, style: 'th', alignment: 'left' },
            { text: vm.$t('org_pro_division.division'), style: 'th', alignment: 'left' },
            { text: data.pr_division, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('org_pro_district.district'), style: 'th', alignment: 'left' },
            { text: data.pr_district, style: 'th', alignment: 'left' },
            { text: data.pr_city_corporation ? vm.$t('org_pro.city_corporation') : vm.$t('org_pro_upazilla.upazilla'), style: 'th', alignment: 'left' },
            { text: data.pr_city_corporation ? data.pr_city_corporation : data.pr_upazila, style: 'th', alignment: 'left' }
          ],
          medicalAssistAddressRow(data, vm),
          [
            { text: vm.$t('externalUser.post_office'), style: 'th', alignment: 'left' },
            { text: i18n.locale === 'en' ? data.med_assistance.address.pr_post_office : data.med_assistance.address.pr_post_office_bn, style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.road_village'), style: 'th', alignment: 'left' },
            { text: i18n.locale === 'en' ? data.med_assistance.address.pr_address : data.med_assistance.address.pr_address_bn, style: 'th', alignment: 'left' }
          ]
        )
        paemanentAddress.push(
          [
            { text: vm.$t('org_pro.area_type'), style: 'th', alignment: 'left' },
            { text: data.pm_area_type, style: 'th', alignment: 'left' },
            { text: vm.$t('org_pro_division.division'), style: 'th', alignment: 'left' },
            { text: data.pm_division, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('org_pro_district.district'), style: 'th', alignment: 'left' },
            { text: data.pm_district, style: 'th', alignment: 'left' },
            { text: data.pm_city_corporation ? vm.$t('org_pro.city_corporation') : vm.$t('org_pro_upazilla.upazilla'), style: 'th', alignment: 'left' },
            { text: data.pm_city_corporation ? data.pm_city_corporation : data.pm_upazila, style: 'th', alignment: 'left' }
          ],
          medicalAssistAddressRow2(data, vm),
          [
            { text: vm.$t('externalUser.post_office'), style: 'th', alignment: 'left' },
            { text: data.med_assistance.address.pm_post_office, style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.road_village'), style: 'th', alignment: 'left' },
            { text: data.med_assistance.address.pm_address, style: 'th', alignment: 'left' }
          ]
        )
      } else if (data.tracking_no === 4) {
        /** Registered General Voluntary Organization */
        generalInformation.push(
          [
            { text: vm.$t('globalTrans.fiscal_year'), style: 'th', alignment: 'left' },
            { text: vm.currentLocale === 'en' ? data.fiscal_year_en : data.fiscal_year_bn, style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.vol_org_name'), style: 'th', alignment: 'left' },
            { text: vm.currentLocale === 'en' ? data.reg_vol_org.vol_org.vol_org_name : data.reg_vol_org.vol_org.vol_org_name_bn, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('externalUser.established_date'), style: 'th', alignment: 'left' },
            { text: vm.$d(new Date(data.reg_vol_org.vol_org.established_date)), style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.registering_authority'), style: 'th', alignment: 'left' },
            { text: vm.currentLocale === 'en' ? data.reg_vol_org.vol_org.regist_author_en : data.reg_vol_org.vol_org.regist_author_bn, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('externalUser.reg_no'), style: 'th', alignment: 'left' },
            { text: (data.reg_vol_org.vol_org.reg_no), style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.registration_date'), style: 'th', alignment: 'left' },
            { text: vm.$d(new Date(data.reg_vol_org.vol_org.regi_date)), style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('externalUser.mobile_no'), style: 'th', alignment: 'left' },
            { text: mobileNumber(data.reg_vol_org.vol_org.c_mobile_no), style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.office_name'), style: 'th', alignment: 'left' },
            { text: data.office_type_name, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('externalUser.application_date'), style: 'th', alignment: 'left' },
            { text: vm.$d(new Date(data.reg_vol_org.app_date)), style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.proposed_amount'), style: 'th', alignment: 'left' },
            { text: vm.$n(data.proposed_amount) + ' ' + vm.$t('globalTrans.taka'), style: 'th', alignment: 'left' }
          ],
          [
            { text: data.approved_amount ? vm.$t('externalUser.approved_amount') : '', style: 'th', alignment: 'left' },
            { text: data.approved_amount ? (vm.$n(data.approved_amount) + ' ' + vm.$t('globalTrans.taka')) : '', style: 'th', alignment: 'left' },
            {},
            {}
          ]
        )
      } else if (data.tracking_no === 5) {
        /** Medical Treatment (Cancer, kidney, liver cirrhosis... */
          generalInformation.push(
            [
              { text: vm.$t('externalUser.father_name'), style: 'th', alignment: 'left' },
              { text: vm.currentLocale === 'en' ? data.medical_treatments.father_name : data.medical_treatments.father_name_bn, style: 'th', alignment: 'left' },
              { text: vm.$t('externalUser.mobile_no'), style: 'th', alignment: 'left' },
              { text: mobileNumber(data.medical_treatments.mobile_no), style: 'th', alignment: 'left' }
            ],
            [
              { text: vm.$t('externalUser.nid_no'), style: 'th', alignment: 'left' },
              { text: mobileNumber(data.medical_treatments.nid_no), style: 'th', alignment: 'left' },
              { text: vm.$t('globalUserData.gender'), style: 'th', alignment: 'left' },
              { text: data.gender_name, style: 'th', alignment: 'left' }
            ],
            [
              { text: vm.$t('externalUser.age'), style: 'th', alignment: 'left' },
              { text: vm.$n(data.medical_treatments.age), style: 'th', alignment: 'left' },
              { text: vm.$t('externalUser.office_name'), style: 'th', alignment: 'left' },
              { text: data.office_type_name, style: 'th', alignment: 'left' }
            ]
          )
      } else if (data.tracking_no === 6) {
        /** Scholarship (Shishu Paribar) */
        pdfContent.push(
        {
          image: await getBase64ImageFromURL(vm.grantAllowanceServiceBaseUrl + 'download-attachment?file=' + '/uploads/grant-panel' + '/' + data.scholarship.image_attachment), width: 70, height: 80, style: 'search', alignment: 'right', rowSpan: 5
        }
        )
        generalInformation.push(
          [
            { text: vm.$t('globalTrans.date_of_birth'), style: 'th', alignment: 'left' },
            { text: dateFormat(data.scholarship.birth_date), style: 'th', alignment: 'left' },
            { text: vm.$t('globalTrans.religion'), style: 'th', alignment: 'left' },
            { text: vm.getReligionName(data.scholarship.religion), style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('externalUser.father_name'), style: 'th', alignment: 'left' },
            { text: vm.currentLocale === 'en' ? data.scholarship.father_name : data.scholarship.father_name_bn, style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.mother_name'), style: 'th', alignment: 'left' },
            { text: vm.currentLocale === 'en' ? data.scholarship.mother_name : data.scholarship.mother_name_bn, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('externalUser.guardian_name'), style: 'th', alignment: 'left' },
            { text: vm.currentLocale === 'en' ? data.scholarship.guardian_name : data.scholarship.guardian_name_bn, style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.study_level'), style: 'th', alignment: 'left' },
            { text: vm.getStudylevelList(data.scholarship.study_level), style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('externalUser.semister'), style: 'th', alignment: 'left' },
            { text: data.scholarship.semester, style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.department'), style: 'th', alignment: 'left' },
            { text: data.scholarship.department, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('externalUser.roll'), style: 'th', alignment: 'left' },
            { text: data.scholarship.semester, style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.cgpax'), style: 'th', alignment: 'left' },
            { text: data.scholarship.department, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('grant_process.org_stu_x'), style: 'th', alignment: 'left', colSpan: 4 },
            { },
            { },
            { }
          ],
          [
            { text: vm.$t('globalTrans.from_date'), style: 'th', alignment: 'left' },
            { text: dateFormat(data.scholarship.from_date), style: 'th', alignment: 'left' },
            { text: vm.$t('globalTrans.to_date'), style: 'th', alignment: 'left' },
            { text: dateFormat(data.scholarship.to_date), style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('externalUser.present_address'), style: 'th', alignment: 'left' },
            { text: vm.currentLocale === 'bn' ? data.scholarship.present_address_bn : data.scholarship.present_address, style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.permanent_address'), style: 'th', alignment: 'left' },
            { text: vm.currentLocale === 'bn' ? data.scholarship.permanent_address_bn : data.scholarship.permanent_address, style: 'th', alignment: 'left' }
          ],
          [
              { text: vm.$t('globalTrans.gender'), style: 'th', alignment: 'left' },
              { text: vm.getGender(data.scholarship.gender), style: 'th', alignment: 'left' },
              { text: vm.$t('externalUser.mobile_no'), style: 'th', alignment: 'left' },
              { text: mobileNumber(data.scholarship.mobile_no), style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('externalUser.nid_brn_no'), style: 'th', alignment: 'left' },
            { text: mobileNumber(data.scholarship.nid_no), style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.office_name'), style: 'th', alignment: 'left' },
            { text: data.office_type_name, style: 'th', alignment: 'left' }
          ]
        )
      } else if (data.tracking_no === 7) {
        /** National level grant */
        generalInformation.push(
          [
            { text: vm.$t('externalUser.registration_no'), style: 'th', alignment: 'left' },
            { text: data.national_level_grants.registration_no, style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.application_date'), style: 'th', alignment: 'left' },
            { text: vm.$d(new Date(data.national_level_grants.application_date)), style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('externalUser.author_contact_no'), style: 'th', alignment: 'left' },
            { text: mobileNumber(data.national_level_grants.mobile_no), style: 'th', alignment: 'left' },
            { text: vm.$t('grant_config.tin_no'), style: 'th', alignment: 'left' },
            { text: (data.national_level_grants.tin_no), style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('grant_config.acknowledgment_date'), style: 'th', alignment: 'left' },
            { text: vm.$d(new Date(data.national_level_grants.established_date)), style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.formation_age'), style: 'th', alignment: 'left' },
            { text: vm.calculateDay(data.national_level_grants.established_date), style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('externalUser.institutes') + ' ' + vm.$t('grant_config.email'), style: 'th', alignment: 'left' },
            { text: data.national_level_grants.email, style: 'th', alignment: 'left' },
            { text: vm.$t('grant_config.website_link'), style: 'th', alignment: 'left' },
            { text: data.national_level_grants.web_url, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('externalUser.proposed_amount'), style: 'th', alignment: 'left' },
            { text: vm.$n(data.proposed_amount) + ' ' + vm.$t('globalTrans.taka'), style: 'th', alignment: 'left' },
            { text: vm.currentLocale === 'en' ? ' (in words) ' : ' (কথায়) ', style: 'th', alignment: 'left' },
            { text: vm.currentLocale === 'en' ? vm.$options.filters.numberToEnglishWords(data.proposed_amount) : vm.$options.filters.numberToBengaliWords(data.proposed_amount), style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('externalUser.details_program_implemented'), style: 'th', alignment: 'left' },
            { text: data.national_level_grants.details_program_implemented, style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.details_program_running'), style: 'th', alignment: 'left' },
            { text: data.national_level_grants.details_program_running, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('externalUser.program_expense_details'), style: 'th', alignment: 'left' },
            { text: data.national_level_grants.program_expense_details, style: 'th', alignment: 'left' },
            {},
            {}
          ],
          [
            { text: vm.$t('externalUser.contact_person_info'), colSpan: 4, style: 'th2', alignment: 'center', bold: true },
            {},
            {},
            {}
          ],
          [
            { text: vm.$t('externalUser.chairman_n_name'), style: 'th', alignment: 'left' },
            { text: vm.currentLocale === 'en' ? data.national_level_grants.c_name_bn : data.national_level_grants.c_name_bn, style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.gen_secretary_name'), style: 'th', alignment: 'left' },
            { text: vm.currentLocale === 'en' ? data.national_level_grants.c_two_name : data.national_level_grants.c_two_name_bn, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('externalUser.chairman_n_mobile'), style: 'th', alignment: 'left' },
            { text: vm.$options.filters.mobileNumber(data.national_level_grants.c_mobile_no), style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.gen_secretary_contact'), style: 'th', alignment: 'left' },
            { text: vm.$options.filters.mobileNumber(data.national_level_grants.c_two_mobile_no), style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$i18n.locale === 'bn' ? 'কার্যনির্বাহী কমিটির  তথ্য' : 'Executive Committee information', colSpan: 4, style: 'th2', alignment: 'center', bold: true },
            {},
            {},
            {}
          ],
          [
            { text: vm.$t('externalUser.executive_start_date'), style: 'th', alignment: 'left' },
            { text: vm.$d(new Date(data.national_level_grants.executive_start_date)), style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.executive_member_no'), style: 'th', alignment: 'left' },
            { text: vm.$n(data.national_level_grants.executive_member_no), style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('externalUser.executive_end_date'), style: 'th', alignment: 'left' },
            { text: vm.$d(new Date(data.national_level_grants.executive_end_date)), style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.executive_committee_duration'), style: 'th', alignment: 'left' },
            { text: data.national_level_grants.executive_committee_duration, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$i18n.locale === 'en' ? 'Details of grants received from the Council for the last three years (where applicable):' : 'পরিষদ হতে প্রাপ্ত বিগত তিন অর্থবছরের অনুদানের তথ্য (প্রযোজ্য ক্ষেত্রে):', colSpan: 4, style: 'th2', alignment: 'center', bold: true },
            {},
            {},
            {}
          ],
          [
            { text: vm.$t('externalUser.fiscalYear'), style: 'th', alignment: 'left', bold: true },
            { text: vm.$t('externalUser.grant_amounts'), style: 'th', alignment: 'left', bold: true },
            { text: vm.$t('externalUser.acitivities_spent'), style: 'th', alignment: 'left', bold: true },
            { text: vm.$t('externalUser.commnet'), style: 'th', alignment: 'left', bold: true }
          ],
          [
            { text: vm.getFiscalYear(JSON.parse(data.national_level_grants.prev_grant_info).prev_fis_one_id), style: 'th', alignment: 'left' },
            { text: (JSON.parse(data.national_level_grants.prev_grant_info).prev_fis_one_amount), style: 'th', alignment: 'left' },
            { text: JSON.parse(data.national_level_grants.prev_grant_info).prev_fis_one_implement, style: 'th', alignment: 'left' },
            { text: JSON.parse(data.national_level_grants.prev_grant_info).prev_fis_one_comment, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.getFiscalYear(JSON.parse(data.national_level_grants.prev_grant_info).prev_fis_two_id), style: 'th', alignment: 'left' },
            { text: (JSON.parse(data.national_level_grants.prev_grant_info).prev_fis_two_amount), style: 'th', alignment: 'left' },
            { text: JSON.parse(data.national_level_grants.prev_grant_info).prev_fis_two_implement, style: 'th', alignment: 'left' },
            { text: JSON.parse(data.national_level_grants.prev_grant_info).prev_fis_two_comment, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.getFiscalYear(JSON.parse(data.national_level_grants.prev_grant_info).prev_fis_three_id), style: 'th', alignment: 'left' },
            { text: (JSON.parse(data.national_level_grants.prev_grant_info).prev_fis_three_amount), style: 'th', alignment: 'left' },
            { text: JSON.parse(data.national_level_grants.prev_grant_info).prev_fis_three_implement, style: 'th', alignment: 'left' },
            { text: JSON.parse(data.national_level_grants.prev_grant_info).prev_fis_three_comment, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$i18n.locale === 'en' ? 'Details of grants received from any source other than the Parishad for the last three years (where applicable):' : 'পরিষদ ছাড়া অন্য কোনো উৎস হতে বিগত তিন অর্থবছরের প্রাপ্ত অনুদানের তথ্য (প্রযোজ্য ক্ষেত্রে):', colSpan: 4, style: 'th2', alignment: 'center', bold: true },
            {},
            {},
            {}
          ],
          [
            { text: vm.$t('externalUser.fiscalYear'), style: 'th', alignment: 'left', bold: true },
            { text: vm.$t('externalUser.grant_amounts'), style: 'th', alignment: 'left', bold: true },
            { text: vm.$t('externalUser.acitivities_spent'), style: 'th', alignment: 'left', bold: true },
            { text: vm.$t('externalUser.commnet'), style: 'th', alignment: 'left', bold: true }
          ],
          [
            { text: vm.getFiscalYear(JSON.parse(data.national_level_grants.prev_grant_other_info).prev_fis_other_one_id), style: 'th', alignment: 'left' },
            { text: (JSON.parse(data.national_level_grants.prev_grant_other_info).prev_fis_other_one_amount), style: 'th', alignment: 'left' },
            { text: JSON.parse(data.national_level_grants.prev_grant_other_info).prev_fis_other_one_implement, style: 'th', alignment: 'left' },
            { text: JSON.parse(data.national_level_grants.prev_grant_other_info).prev_fis_other_one_comment, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.getFiscalYear(JSON.parse(data.national_level_grants.prev_grant_other_info).prev_fis_other_two_id), style: 'th', alignment: 'left' },
            { text: (JSON.parse(data.national_level_grants.prev_grant_other_info).prev_fis_other_two_amount), style: 'th', alignment: 'left' },
            { text: JSON.parse(data.national_level_grants.prev_grant_other_info).prev_fis_other_two_implement, style: 'th', alignment: 'left' },
            { text: JSON.parse(data.national_level_grants.prev_grant_other_info).prev_fis_other_two_comment, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.getFiscalYear(JSON.parse(data.national_level_grants.prev_grant_other_info).prev_fis_other_three_id), style: 'th', alignment: 'left' },
            { text: (JSON.parse(data.national_level_grants.prev_grant_other_info).prev_fis_other_three_amount), style: 'th', alignment: 'left' },
            { text: JSON.parse(data.national_level_grants.prev_grant_other_info).prev_fis_other_three_implement, style: 'th', alignment: 'left' },
            { text: JSON.parse(data.national_level_grants.prev_grant_other_info).prev_fis_other_three_comment, style: 'th', alignment: 'left' }
          ]
        )
      } else if (data.tracking_no === 8) {
        /** Patient's Welfare Association */
        generalInformation.push(
          [
            { text: vm.$t('globalTrans.fiscal_year'), style: 'th', alignment: 'left' },
            { text: vm.currentLocale === 'en' ? data.fiscal_year_en : data.fiscal_year_bn, style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.association_contact_no') + vm.$t('externalUser.short'), style: 'th', alignment: 'left' },
            { text: mobileNumber(data.patient_welfare_assoc.mobile_no), style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('externalUser.reg_no'), style: 'th', alignment: 'left' },
            { text: data.patient_welfare_assoc.registration_no, style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.registration_date'), style: 'th', alignment: 'left' },
            { text: vm.$d(new Date(data.patient_welfare_assoc.regi_date)), style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('externalUser.association') + ' ' + vm.$t('grant_config.email'), style: 'th', alignment: 'left' },
            { text: data.patient_welfare_assoc.email, style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.website_link_x_x_x'), style: 'th', alignment: 'left' },
            { text: (data.patient_welfare_assoc.web_url), style: 'th', alignment: 'left' }
          ],
          // [
          //   { text: vm.$t('externalUser.formations_date'), style: 'th', alignment: 'left' },
          //   { text: vm.$d(new Date(data.patient_welfare_assoc.established_date)), style: 'th', alignment: 'left' },
          //   { text: vm.$t('externalUser.formations_age'), style: 'th', alignment: 'left' },
          //   { text: vm.$calculateDay(data.patient_welfare_assoc.established_date), style: 'th', alignment: 'left' }
          // ],
          [
            { text: vm.$t('externalUser.application_date'), style: 'th', alignment: 'left' },
            { text: vm.$d(new Date(data.patient_welfare_assoc.application_date)), style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.registering_authority'), style: 'th', alignment: 'left' },
            { text: vm.currentLocale === 'en' ? data.patient_welfare_assoc.regist_author_en : data.patient_welfare_assoc.regist_author_bn, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('externalUser.application_class_x'), style: 'th', alignment: 'left' },
            { text: data.application_class_name, style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.office_name'), style: 'th', alignment: 'left' },
            { text: data.office_type_name, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('externalUser.formations_date'), style: 'th', alignment: 'left' },
            { text: vm.$d(new Date(data.patient_welfare_assoc.established_date)), style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.formation_age'), style: 'th', alignment: 'left' },
            { text: vm.calculateDay(data.patient_welfare_assoc.established_date), style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('externalUser.proposed_amount'), style: 'th', alignment: 'left' },
            { text: vm.$n(data.proposed_amount) + ' ' + vm.$t('globalTrans.taka'), style: 'th', alignment: 'left' },
            { text: vm.currentLocale === 'en' ? ' (in words) ' : ' (কথায়) ', style: 'th', alignment: 'left' },
            { text: vm.currentLocale === 'en' ? vm.$options.filters.numberToEnglishWords(data.proposed_amount) : vm.$options.filters.numberToBengaliWords(data.proposed_amount), style: 'th', alignment: 'left' }
          ],
          [
            { text: data.approved_amount ? vm.$t('externalUser.approved_amount') : '', style: 'th', alignment: 'left' },
            { text: data.approved_amount ? (vm.$n(data.approved_amount) + ' ' + vm.$t('globalTrans.taka')) : '', style: 'th', alignment: 'left' },
            {},
            {}
          ],
          [
            { text: vm.$t('externalUser.details_program_implemented') + vm.$t('externalUser.short'), style: 'th', alignment: 'left' },
            { text: data.patient_welfare_assoc.details_program_implemented, style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.details_program_running'), style: 'th', alignment: 'left' },
            { text: data.patient_welfare_assoc.details_program_running, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('externalUser.program_expense_details'), style: 'th', alignment: 'left' },
            { text: data.patient_welfare_assoc.program_expense_details, style: 'th', alignment: 'left' },
            {},
            {}
          ],
          [
            { text: vm.$t('externalUser.pat_association_info'), colSpan: 4, style: 'th2', alignment: 'center', bold: true },
            {},
            {},
            {}
          ],
          [
            { text: vm.$t('externalUser.chairman_name'), style: 'th', alignment: 'left' },
            { text: vm.currentLocale === 'en' ? data.patient_welfare_assoc.c_name_bn : data.patient_welfare_assoc.c_name_bn, style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.gen_secretary_name'), style: 'th', alignment: 'left' },
            { text: vm.currentLocale === 'en' ? data.patient_welfare_assoc.c_two_name : data.patient_welfare_assoc.c_two_name_bn, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('externalUser.chairman_contact'), style: 'th', alignment: 'left' },
            { text: vm.$options.filters.mobileNumber(data.patient_welfare_assoc.c_mobile_no), style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.gen_secretary_contact'), style: 'th', alignment: 'left' },
            { text: vm.$options.filters.mobileNumber(data.patient_welfare_assoc.c_two_mobile_no), style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$i18n.locale === 'bn' ? 'কার্যনির্বাহী কমিটির  তথ্য' : 'Executive Committee information', colSpan: 4, style: 'th2', alignment: 'center', bold: true },
            {},
            {},
            {}
          ],
          [
            { text: vm.$t('externalUser.executive_start_date'), style: 'th', alignment: 'left' },
            { text: vm.$d(new Date(data.patient_welfare_assoc.executive_start_date)), style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.executive_member_no'), style: 'th', alignment: 'left' },
            { text: vm.$n(data.patient_welfare_assoc.executive_member_no), style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('externalUser.executive_end_date'), style: 'th', alignment: 'left' },
            { text: vm.$d(new Date(data.patient_welfare_assoc.executive_end_date)), style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.executive_committee_duration'), style: 'th', alignment: 'left' },
            { text: data.patient_welfare_assoc.executive_committee_duration, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$i18n.locale === 'en' ? 'Details of grants received from the Council for the last three years (where applicable):' : 'পরিষদ হতে প্রাপ্ত বিগত তিন অর্থবছরের অনুদানের তথ্য (প্রযোজ্য ক্ষেত্রে):', colSpan: 4, style: 'th2', alignment: 'center', bold: true },
            {},
            {},
            {}
          ],
          [
            { text: vm.$t('externalUser.fiscalYear'), style: 'th', alignment: 'left', bold: true },
            { text: vm.$t('externalUser.grant_amounts'), style: 'th', alignment: 'left', bold: true },
            { text: vm.$t('externalUser.acitivities_spent'), style: 'th', alignment: 'left', bold: true },
            { text: vm.$t('externalUser.commnet'), style: 'th', alignment: 'left', bold: true }
          ],
          [
            { text: vm.getFiscalYear(JSON.parse(data.patient_welfare_assoc.prev_grant_info).prev_fis_one_id), style: 'th', alignment: 'left' },
            { text: (JSON.parse(data.patient_welfare_assoc.prev_grant_info).prev_fis_one_amount), style: 'th', alignment: 'left' },
            { text: JSON.parse(data.patient_welfare_assoc.prev_grant_info).prev_fis_one_implement, style: 'th', alignment: 'left' },
            { text: JSON.parse(data.patient_welfare_assoc.prev_grant_info).prev_fis_one_comment, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.getFiscalYear(JSON.parse(data.patient_welfare_assoc.prev_grant_info).prev_fis_two_id), style: 'th', alignment: 'left' },
            { text: (JSON.parse(data.patient_welfare_assoc.prev_grant_info).prev_fis_two_amount), style: 'th', alignment: 'left' },
            { text: JSON.parse(data.patient_welfare_assoc.prev_grant_info).prev_fis_two_implement, style: 'th', alignment: 'left' },
            { text: JSON.parse(data.patient_welfare_assoc.prev_grant_info).prev_fis_two_comment, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.getFiscalYear(JSON.parse(data.patient_welfare_assoc.prev_grant_info).prev_fis_three_id), style: 'th', alignment: 'left' },
            { text: (JSON.parse(data.patient_welfare_assoc.prev_grant_info).prev_fis_three_amount), style: 'th', alignment: 'left' },
            { text: JSON.parse(data.patient_welfare_assoc.prev_grant_info).prev_fis_three_implement, style: 'th', alignment: 'left' },
            { text: JSON.parse(data.patient_welfare_assoc.prev_grant_info).prev_fis_three_comment, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$i18n.locale === 'en' ? 'Details of grants received from any source other than the Parishad for the last three years (where applicable):' : 'পরিষদ ছাড়া অন্য কোনো উৎস হতে বিগত তিন অর্থবছরের প্রাপ্ত অনুদানের তথ্য (প্রযোজ্য ক্ষেত্রে):', colSpan: 4, style: 'th2', alignment: 'center', bold: true },
            {},
            {},
            {}
          ],
          [
            { text: vm.$t('externalUser.fiscalYear'), style: 'th', alignment: 'left', bold: true },
            { text: vm.$t('externalUser.grant_amounts'), style: 'th', alignment: 'left', bold: true },
            { text: vm.$t('externalUser.acitivities_spent'), style: 'th', alignment: 'left', bold: true },
            { text: vm.$t('externalUser.commnet'), style: 'th', alignment: 'left', bold: true }
          ],
          [
            { text: vm.getFiscalYear(JSON.parse(data.patient_welfare_assoc.prev_grant_other_info).prev_fis_other_one_id), style: 'th', alignment: 'left' },
            { text: (JSON.parse(data.patient_welfare_assoc.prev_grant_other_info).prev_fis_other_one_amount), style: 'th', alignment: 'left' },
            { text: JSON.parse(data.patient_welfare_assoc.prev_grant_other_info).prev_fis_other_one_implement, style: 'th', alignment: 'left' },
            { text: JSON.parse(data.patient_welfare_assoc.prev_grant_other_info).prev_fis_other_one_comment, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.getFiscalYear(JSON.parse(data.patient_welfare_assoc.prev_grant_other_info).prev_fis_other_two_id), style: 'th', alignment: 'left' },
            { text: (JSON.parse(data.patient_welfare_assoc.prev_grant_other_info).prev_fis_other_two_amount), style: 'th', alignment: 'left' },
            { text: JSON.parse(data.patient_welfare_assoc.prev_grant_other_info).prev_fis_other_two_implement, style: 'th', alignment: 'left' },
            { text: JSON.parse(data.patient_welfare_assoc.prev_grant_other_info).prev_fis_other_two_comment, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.getFiscalYear(JSON.parse(data.patient_welfare_assoc.prev_grant_other_info).prev_fis_other_three_id), style: 'th', alignment: 'left' },
            { text: (JSON.parse(data.patient_welfare_assoc.prev_grant_other_info).prev_fis_other_three_amount), style: 'th', alignment: 'left' },
            { text: JSON.parse(data.patient_welfare_assoc.prev_grant_other_info).prev_fis_other_three_implement, style: 'th', alignment: 'left' },
            { text: JSON.parse(data.patient_welfare_assoc.prev_grant_other_info).prev_fis_other_three_comment, style: 'th', alignment: 'left' }
          ]
        )
      } else if (data.tracking_no === 9) {
        /** National level grant */
        generalInformation.push(
          [
            { text: vm.$t('externalUser.registration_no'), style: 'th', alignment: 'left' },
            { text: data.correction_of_offender.registration_no, style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.registration_date'), style: 'th', alignment: 'left' },
            { text: vm.$d(new Date(data.correction_of_offender.regi_date)), style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('externalUser.author_contact_council_no'), style: 'th', alignment: 'left' },
            { text: data.correction_of_offender.mobile_no, style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.application_date'), style: 'th', alignment: 'left' },
            { text: vm.$d(new Date(data.correction_of_offender.application_date)), style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('externalUser.author_contact_offender_no'), style: 'th', alignment: 'left' },
            { text: mobileNumber(data.correction_of_offender.mobile_no), style: 'th', alignment: 'left' },
            { text: vm.$t('grant_config.tin_no'), style: 'th', alignment: 'left' },
            { text: (data.correction_of_offender.tin_no), style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('externalUser.offender_correction') + ' ' + vm.$t('grant_config.email'), style: 'th', alignment: 'left' },
            { text: data.correction_of_offender.email, style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.website_link_x_x'), style: 'th', alignment: 'left' },
            { text: data.correction_of_offender.web_url, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('externalUser.proposed_amount'), style: 'th', alignment: 'left' },
            { text: vm.$n(data.proposed_amount) + ' ' + vm.$t('globalTrans.taka'), style: 'th', alignment: 'left' },
            { text: vm.currentLocale === 'en' ? ' (in words) ' : ' (কথায়) ', style: 'th', alignment: 'left' },
            { text: vm.currentLocale === 'en' ? vm.$options.filters.numberToEnglishWords(data.proposed_amount) : vm.$options.filters.numberToBengaliWords(data.proposed_amount), style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('externalUser.details_program_implemented') + vm.$t('externalUser.short'), style: 'th', alignment: 'left' },
            { text: data.correction_of_offender.details_program_implemented, style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.details_program_running'), style: 'th', alignment: 'left' },
            { text: data.correction_of_offender.details_program_running, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('externalUser.program_expense_details'), style: 'th', alignment: 'left' },
            { text: data.correction_of_offender.program_expense_details, style: 'th', alignment: 'left' },
            {},
            {}
          ],
          [
            { text: vm.$t('externalUser.contact_person_info_offender'), colSpan: 4, style: 'th2', alignment: 'center', bold: true },
            {},
            {},
            {}
          ],
          [
            { text: vm.$t('externalUser.chairman_name'), style: 'th', alignment: 'left' },
            { text: vm.currentLocale === 'en' ? data.correction_of_offender.c_name_bn : data.correction_of_offender.c_name_bn, style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.gen_secretary_name'), style: 'th', alignment: 'left' },
            { text: vm.currentLocale === 'en' ? data.correction_of_offender.c_two_name : data.correction_of_offender.c_two_name_bn, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('externalUser.chairman_contact'), style: 'th', alignment: 'left' },
            { text: vm.$options.filters.mobileNumber(data.correction_of_offender.c_mobile_no), style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.gen_secretary_contact'), style: 'th', alignment: 'left' },
            { text: vm.$options.filters.mobileNumber(data.correction_of_offender.c_two_mobile_no), style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('globalTrans.designation'), style: 'th', alignment: 'left' },
            { text: vm.currentLocale === 'en' ? data.correction_of_offender.c_designation_bn : data.correction_of_offender.c_designation_bn, style: 'th', alignment: 'left' },
            { text: vm.$t('globalTrans.designation'), style: 'th', alignment: 'left' },
            { text: vm.currentLocale === 'en' ? data.correction_of_offender.c_two_designation : data.correction_of_offender.c_two_designation_bn, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$i18n.locale === 'bn' ? 'কার্যনির্বাহী কমিটির  তথ্য' : 'Executive Committee information', colSpan: 4, style: 'th2', alignment: 'center', bold: true },
            {},
            {},
            {}
          ],
          [
            { text: vm.$t('externalUser.executive_start_date'), style: 'th', alignment: 'left' },
            { text: vm.$d(new Date(data.correction_of_offender.executive_start_date)), style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.executive_member_no'), style: 'th', alignment: 'left' },
            { text: vm.$n(data.correction_of_offender.executive_member_no), style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('externalUser.executive_end_date'), style: 'th', alignment: 'left' },
            { text: vm.$d(new Date(data.correction_of_offender.executive_end_date)), style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.executive_committee_duration'), style: 'th', alignment: 'left' },
            { text: data.correction_of_offender.executive_committee_duration, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$i18n.locale === 'en' ? 'Details of grants received from the Council for the last three years (where applicable):' : 'পরিষদ হতে প্রাপ্ত বিগত তিন অর্থবছরের অনুদানের তথ্য (প্রযোজ্য ক্ষেত্রে):', colSpan: 4, style: 'th2', alignment: 'center', bold: true },
            {},
            {},
            {}
          ],
          [
            { text: vm.$t('externalUser.fiscalYear'), style: 'th', alignment: 'left', bold: true },
            { text: vm.$t('externalUser.grant_amounts'), style: 'th', alignment: 'left', bold: true },
            { text: vm.$t('externalUser.acitivities_spent'), style: 'th', alignment: 'left', bold: true },
            { text: vm.$t('externalUser.commnet'), style: 'th', alignment: 'left', bold: true }
          ],
          [
            { text: vm.getFiscalYear(JSON.parse(data.correction_of_offender.prev_grant_info).prev_fis_one_id), style: 'th', alignment: 'left' },
            { text: (JSON.parse(data.correction_of_offender.prev_grant_info).prev_fis_one_amount), style: 'th', alignment: 'left' },
            { text: JSON.parse(data.correction_of_offender.prev_grant_info).prev_fis_one_implement, style: 'th', alignment: 'left' },
            { text: JSON.parse(data.correction_of_offender.prev_grant_info).prev_fis_one_comment, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.getFiscalYear(JSON.parse(data.correction_of_offender.prev_grant_info).prev_fis_two_id), style: 'th', alignment: 'left' },
            { text: (JSON.parse(data.correction_of_offender.prev_grant_info).prev_fis_two_amount), style: 'th', alignment: 'left' },
            { text: JSON.parse(data.correction_of_offender.prev_grant_info).prev_fis_two_implement, style: 'th', alignment: 'left' },
            { text: JSON.parse(data.correction_of_offender.prev_grant_info).prev_fis_two_comment, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.getFiscalYear(JSON.parse(data.correction_of_offender.prev_grant_info).prev_fis_three_id), style: 'th', alignment: 'left' },
            { text: (JSON.parse(data.correction_of_offender.prev_grant_info).prev_fis_three_amount), style: 'th', alignment: 'left' },
            { text: JSON.parse(data.correction_of_offender.prev_grant_info).prev_fis_three_implement, style: 'th', alignment: 'left' },
            { text: JSON.parse(data.correction_of_offender.prev_grant_info).prev_fis_three_comment, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$i18n.locale === 'en' ? 'Details of grants received from any source other than the Parishad for the last three years (where applicable):' : 'পরিষদ ছাড়া অন্য কোনো উৎস হতে বিগত তিন অর্থবছরের প্রাপ্ত অনুদানের তথ্য (প্রযোজ্য ক্ষেত্রে):', colSpan: 4, style: 'th2', alignment: 'center', bold: true },
            {},
            {},
            {}
          ],
          [
            { text: vm.$t('externalUser.fiscalYear'), style: 'th', alignment: 'left', bold: true },
            { text: vm.$t('externalUser.grant_amounts'), style: 'th', alignment: 'left', bold: true },
            { text: vm.$t('externalUser.acitivities_spent'), style: 'th', alignment: 'left', bold: true },
            { text: vm.$t('externalUser.commnet'), style: 'th', alignment: 'left', bold: true }
          ],
          [
            { text: vm.getFiscalYear(JSON.parse(data.correction_of_offender.prev_grant_other_info).prev_fis_other_one_id), style: 'th', alignment: 'left' },
            { text: (JSON.parse(data.correction_of_offender.prev_grant_other_info).prev_fis_other_one_amount), style: 'th', alignment: 'left' },
            { text: JSON.parse(data.correction_of_offender.prev_grant_other_info).prev_fis_other_one_implement, style: 'th', alignment: 'left' },
            { text: JSON.parse(data.correction_of_offender.prev_grant_other_info).prev_fis_other_one_comment, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.getFiscalYear(JSON.parse(data.correction_of_offender.prev_grant_other_info).prev_fis_other_two_id), style: 'th', alignment: 'left' },
            { text: (JSON.parse(data.correction_of_offender.prev_grant_other_info).prev_fis_other_two_amount), style: 'th', alignment: 'left' },
            { text: JSON.parse(data.correction_of_offender.prev_grant_other_info).prev_fis_other_two_implement, style: 'th', alignment: 'left' },
            { text: JSON.parse(data.correction_of_offender.prev_grant_other_info).prev_fis_other_two_comment, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.getFiscalYear(JSON.parse(data.correction_of_offender.prev_grant_other_info).prev_fis_other_three_id), style: 'th', alignment: 'left' },
            { text: (JSON.parse(data.correction_of_offender.prev_grant_other_info).prev_fis_other_three_amount), style: 'th', alignment: 'left' },
            { text: JSON.parse(data.correction_of_offender.prev_grant_other_info).prev_fis_other_three_implement, style: 'th', alignment: 'left' },
            { text: JSON.parse(data.correction_of_offender.prev_grant_other_info).prev_fis_other_three_comment, style: 'th', alignment: 'left' }
          ]
        )
      } else if (data.tracking_no === 10) {
        /** National level grant */
        generalInformation.push(
          [
            { text: vm.$t('externalUser.registration_no'), style: 'th', alignment: 'left' },
            { text: data.coordination_council.registration_no, style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.regi_date_x'), style: 'th', alignment: 'left' },
            { text: vm.$d(new Date(data.coordination_council.regi_date)), style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('externalUser.author_contact_council_no'), style: 'th', alignment: 'left' },
            { text: mobileNumber(data.coordination_council.mobile_no), style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.application_date'), style: 'th', alignment: 'left' },
            { text: vm.$d(new Date(data.coordination_council.application_date)), style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('externalUser.formation_date_coordination_council'), style: 'th', alignment: 'left' },
            { text: vm.$d(new Date(data.coordination_council.formation_date)), style: 'th', alignment: 'left' },
            { text: vm.$t('grant_config.tin_no'), style: 'th', alignment: 'left' },
            { text: (data.coordination_council.tin_no), style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('externalUser.coordination_council') + ' ' + vm.$t('grant_config.email'), style: 'th', alignment: 'left' },
            { text: data.coordination_council.email, style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.website_link_x'), style: 'th', alignment: 'left' },
            { text: data.coordination_council.web_url, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('externalUser.proposed_amount'), style: 'th', alignment: 'left' },
            { text: vm.$n(data.proposed_amount) + ' ' + vm.$t('globalTrans.taka'), style: 'th', alignment: 'left' },
            { text: vm.currentLocale === 'en' ? ' (in words) ' : ' (কথায়) ', style: 'th', alignment: 'left' },
            { text: vm.currentLocale === 'en' ? vm.$options.filters.numberToEnglishWords(data.proposed_amount) : vm.$options.filters.numberToBengaliWords(data.proposed_amount), style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('externalUser.details_program_implemented') + vm.$t('externalUser.short'), style: 'th', alignment: 'left' },
            { text: data.coordination_council.details_program_implemented, style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.details_program_running'), style: 'th', alignment: 'left' },
            { text: data.coordination_council.details_program_running, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('externalUser.program_expense_details'), style: 'th', alignment: 'left' },
            { text: data.coordination_council.program_expense_details, style: 'th', alignment: 'left' },
            {},
            {}
          ],
          [
            { text: vm.$t('externalUser.contact_person_info_council'), colSpan: 4, style: 'th2', alignment: 'center', bold: true },
            {},
            {},
            {}
          ],
          [
            { text: vm.$t('externalUser.chairman_name'), style: 'th', alignment: 'left' },
            { text: vm.currentLocale === 'en' ? data.coordination_council.c_name_bn : data.coordination_council.c_name_bn, style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.gen_secretary_name'), style: 'th', alignment: 'left' },
            { text: vm.currentLocale === 'en' ? data.coordination_council.c_two_name : data.coordination_council.c_two_name_bn, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('externalUser.chairman_contact'), style: 'th', alignment: 'left' },
            { text: vm.$options.filters.mobileNumber(data.coordination_council.c_mobile_no), style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.gen_secretary_contact'), style: 'th', alignment: 'left' },
            { text: vm.$options.filters.mobileNumber(data.coordination_council.c_two_mobile_no), style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('globalTrans.designation'), style: 'th', alignment: 'left' },
            { text: vm.currentLocale === 'en' ? data.coordination_council.c_designation_bn : data.coordination_council.c_designation_bn, style: 'th', alignment: 'left' },
            { text: vm.$t('globalTrans.designation'), style: 'th', alignment: 'left' },
            { text: vm.currentLocale === 'en' ? data.coordination_council.c_two_designation : data.coordination_council.c_two_designation_bn, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('externalUser.council_committee'), colSpan: 4, style: 'th2', alignment: 'center', bold: true },
            {},
            {},
            {}
          ],
          [
            { text: vm.$t('externalUser.executive_start_date'), style: 'th', alignment: 'left' },
            { text: vm.$d(new Date(data.coordination_council.executive_start_date)), style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.executive_member_no'), style: 'th', alignment: 'left' },
            { text: vm.$n(data.coordination_council.executive_member_no), style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('externalUser.executive_end_date'), style: 'th', alignment: 'left' },
            { text: vm.$d(new Date(data.coordination_council.executive_end_date)), style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.executive_committee_duration'), style: 'th', alignment: 'left' },
            { text: data.coordination_council.executive_committee_duration, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$i18n.locale === 'en' ? 'Details of grants received from the Council for the last three years (where applicable):' : 'পরিষদ হতে প্রাপ্ত বিগত তিন অর্থবছরের অনুদানের তথ্য (প্রযোজ্য ক্ষেত্রে):', colSpan: 4, style: 'th2', alignment: 'center', bold: true },
            {},
            {},
            {}
          ],
          [
            { text: vm.$t('externalUser.fiscalYear'), style: 'th', alignment: 'left', bold: true },
            { text: vm.$t('externalUser.grant_amounts'), style: 'th', alignment: 'left', bold: true },
            { text: vm.$t('externalUser.acitivities_spent'), style: 'th', alignment: 'left', bold: true },
            { text: vm.$t('externalUser.commnet'), style: 'th', alignment: 'left', bold: true }
          ],
          [
            { text: vm.getFiscalYear(JSON.parse(data.coordination_council.prev_grant_info).prev_fis_one_id), style: 'th', alignment: 'left' },
            { text: (JSON.parse(data.coordination_council.prev_grant_info).prev_fis_one_amount), style: 'th', alignment: 'left' },
            { text: JSON.parse(data.coordination_council.prev_grant_info).prev_fis_one_implement, style: 'th', alignment: 'left' },
            { text: JSON.parse(data.coordination_council.prev_grant_info).prev_fis_one_comment, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.getFiscalYear(JSON.parse(data.coordination_council.prev_grant_info).prev_fis_two_id), style: 'th', alignment: 'left' },
            { text: (JSON.parse(data.coordination_council.prev_grant_info).prev_fis_two_amount), style: 'th', alignment: 'left' },
            { text: JSON.parse(data.coordination_council.prev_grant_info).prev_fis_two_implement, style: 'th', alignment: 'left' },
            { text: JSON.parse(data.coordination_council.prev_grant_info).prev_fis_two_comment, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.getFiscalYear(JSON.parse(data.coordination_council.prev_grant_info).prev_fis_three_id), style: 'th', alignment: 'left' },
            { text: (JSON.parse(data.coordination_council.prev_grant_info).prev_fis_three_amount), style: 'th', alignment: 'left' },
            { text: JSON.parse(data.coordination_council.prev_grant_info).prev_fis_three_implement, style: 'th', alignment: 'left' },
            { text: JSON.parse(data.coordination_council.prev_grant_info).prev_fis_three_comment, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$i18n.locale === 'en' ? 'Details of grants received from any source other than the Parishad for the last three years (where applicable):' : 'পরিষদ ছাড়া অন্য কোনো উৎস হতে বিগত তিন অর্থবছরের প্রাপ্ত অনুদানের তথ্য (প্রযোজ্য ক্ষেত্রে):', colSpan: 4, style: 'th2', alignment: 'center', bold: true },
            {},
            {},
            {}
          ],
          [
            { text: vm.$t('externalUser.fiscalYear'), style: 'th', alignment: 'left', bold: true },
            { text: vm.$t('externalUser.grant_amounts'), style: 'th', alignment: 'left', bold: true },
            { text: vm.$t('externalUser.acitivities_spent'), style: 'th', alignment: 'left', bold: true },
            { text: vm.$t('externalUser.commnet'), style: 'th', alignment: 'left', bold: true }
          ],
          [
            { text: vm.getFiscalYear(JSON.parse(data.coordination_council.prev_grant_other_info).prev_fis_other_one_id), style: 'th', alignment: 'left' },
            { text: (JSON.parse(data.coordination_council.prev_grant_other_info).prev_fis_other_one_amount), style: 'th', alignment: 'left' },
            { text: JSON.parse(data.coordination_council.prev_grant_other_info).prev_fis_other_one_implement, style: 'th', alignment: 'left' },
            { text: JSON.parse(data.coordination_council.prev_grant_other_info).prev_fis_other_one_comment, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.getFiscalYear(JSON.parse(data.coordination_council.prev_grant_other_info).prev_fis_other_two_id), style: 'th', alignment: 'left' },
            { text: (JSON.parse(data.coordination_council.prev_grant_other_info).prev_fis_other_two_amount), style: 'th', alignment: 'left' },
            { text: JSON.parse(data.coordination_council.prev_grant_other_info).prev_fis_other_two_implement, style: 'th', alignment: 'left' },
            { text: JSON.parse(data.coordination_council.prev_grant_other_info).prev_fis_other_two_comment, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.getFiscalYear(JSON.parse(data.coordination_council.prev_grant_other_info).prev_fis_other_three_id), style: 'th', alignment: 'left' },
            { text: (JSON.parse(data.coordination_council.prev_grant_other_info).prev_fis_other_three_amount), style: 'th', alignment: 'left' },
            { text: JSON.parse(data.coordination_council.prev_grant_other_info).prev_fis_other_three_implement, style: 'th', alignment: 'left' },
            { text: JSON.parse(data.coordination_council.prev_grant_other_info).prev_fis_other_three_comment, style: 'th', alignment: 'left' }
          ]
        )
      } else if (data.tracking_no === 11) {
        /** Special Grant */
        generalInformation.push(
          [
            { text: vm.$t('externalUser.father_name'), style: 'th', alignment: 'left' },
            { text: vm.currentLocale === 'en' ? data.special_grant.father_name : data.special_grant.father_name_bn, style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.mobile_no'), style: 'th', alignment: 'left' },
            { text: mobileNumber(data.special_grant.mobile_no), style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('externalUser.nid_no'), style: 'th', alignment: 'left' },
            { text: mobileNumber(data.special_grant.nid), style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.date_of_birth'), style: 'th', alignment: 'left' },
            { text: vm.$d(new Date(data.special_grant.date_of_birth)), style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('externalUser.application_date'), style: 'th', alignment: 'left' },
            { text: vm.$d(new Date(data.special_grant.application_date)), style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.office_name'), style: 'th', alignment: 'left' },
            { text: data.office_type_name, style: 'th', alignment: 'left' }
          ]
        )
      } else if (data.tracking_no === 12) {
        /** National Disability Development Foundation Grant(organization) */
        generalInformation.push(
          [
            { text: vm.$t('externalUser.org_type'), style: 'th', alignment: 'left' },
            { text: vm.currentLocale === 'en' ? data.nat_dis_dev_foundation.org_type : data.nat_dis_dev_foundation.org_type_bn, style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.application_date'), style: 'th', alignment: 'left' },
            { text: vm.$d(new Date(data.nat_dis_dev_foundation.application_date)), style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('externalUser.mobile_no'), style: 'th', alignment: 'left' },
            { text: mobileNumber(data.nat_dis_dev_foundation.mobile_no), style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.reg_no'), style: 'th', alignment: 'left' },
            { text: vm.$n(data.nat_dis_dev_foundation.reg_no, { useGrouping: false }), style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('externalUser.office_name'), style: 'th', alignment: 'left' },
            { text: data.office_type_name, style: 'th', alignment: 'left' },
            {},
            {}
          ]
        )
      } else if (data.tracking_no === 13) {
        /** National Disability Development Foundation Grant(Personal) */
        generalInformation.push(
          [
            { text: vm.$t('globalTrans.father_name'), style: 'th', alignment: 'left' },
            { text: i18n.locale === 'en' ? data.grant_personal.father_name : data.grant_personal.father_name_bn, style: 'th', alignment: 'left' },
            { text: vm.$t('globalTrans.mother_name'), style: 'th', alignment: 'left' },
            { text: i18n.locale === 'en' ? data.grant_personal.mother_name : data.grant_personal.mother_name_bn, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('externalUser.mobile_no'), style: 'th', alignment: 'left' },
            { text: mobileNumber(data.grant_personal.mobile_no), style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.disability_reg_no'), style: 'th', alignment: 'left' },
            { text: data.grant_personal.disability_reg_no, style: 'th', alignment: 'left' }
          ],
          [
            { text: data.grant_personal.nid_no ? vm.$t('externalUser.nid_no') : vm.$t('externalUser.brs_no'), style: 'th', alignment: 'left' },
            { text: data.grant_personal.nid_no ? vm.$n(data.grant_personal.nid_no, { useGrouping: false }) : vm.$n(data.grant_personal.birth_reg_no, { useGrouping: false }), style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.office_name'), style: 'th', alignment: 'left' },
            { text: data.office_type_name, style: 'th', alignment: 'left' }
          ]
        )
      }

      pdfContent.push({
        table: {
          headerRows: 0,
          widths: ['25%', '25%', '25%', '25%'],
          body: generalInformation
        },
        layout: {
          hLineWidth: function (i, node) {
            return 0
          },
          vLineWidth: function (i, node) {
            return 0
          }
        }
      })

      if (presentAddress.length > 1) {
        pdfContent.push({ text: '', style: 'empty_space' })
        pdfContent.push({
          table: {
            headerRows: 0,
            widths: ['25%', '25%', '25%', '25%'],
            body: presentAddress
          },
          layout: {
            hLineWidth: function (i, node) {
              return 0
            },
            vLineWidth: function (i, node) {
              return 0
            }
          }
        })
      }
      if (paemanentAddress.length > 1) {
        pdfContent.push({ text: '', style: 'empty_space' })
        pdfContent.push({
          table: {
            headerRows: 0,
            widths: ['25%', '25%', '25%', '25%'],
            body: paemanentAddress
          },
          layout: {
            hLineWidth: function (i, node) {
              return 0
            },
            vLineWidth: function (i, node) {
              return 0
            }
          }
        })
      }

      // pdfContent.push({ text: '', style: 'empty_space' })
      /** <!-- General Information --> */

      if (data.tracking_no === 2) {
        pdfContent.push({ text: '', style: 'empty_space' })
        const rasendentInfo = [
          [
            { text: vm.$t('externalUser.ins_wise_Student'), style: 'th2', alignment: 'center', bold: true }
          ]
        ]
        pdfContent.push({
          table: {
            headerRows: 0,
            widths: ['100%'],
            body: rasendentInfo
          },
          layout: {
            hLineWidth: function (i, node) {
              return 0
            },
            vLineWidth: function (i, node) {
              return 0
            }
          }
        })
        pdfContent.push({ text: '', style: 'empty_space' })
        if (vm.studentsArray.length > 0) {
          const allRowsHead = [
            [
              { text: vm.$t('globalTrans.sl_no'), style: 'th', alignment: 'center' },
              { text: vm.$t('externalUser.student_name_x'), style: 'th', alignment: 'center' },
              { text: vm.$t('externalUser.father_name'), style: 'th', alignment: 'center' },
              { text: vm.$t('externalUser.mother_name'), style: 'th', alignment: 'center' },
              { text: vm.$t('globalTrans.age'), style: 'th', alignment: 'center' }
            ]
          ]
          vm.studentsArray.map((item, index) => {
            allRowsHead.push(
            [
              { text: vm.$n(index + 1), style: 'td', alignment: 'center' },
              { text: vm.$i18n.locale === 'en' ? item.students.student_name_en : item.students.student_name_bn, style: 'td', alignment: 'center' },
              { text: vm.$i18n.locale === 'en' ? item.students.father_name_en : item.students.father_name_bn, style: 'td', alignment: 'center' },
              { text: vm.$i18n.locale === 'en' ? item.students.mother_name_en : item.students.mother_name_bn, style: 'td', alignment: 'center' },
              { text: vm.$n(item.students.age), style: 'td', alignment: 'center' }
            ])
          })
          pdfContent.push({
            table: {
              headerRows: 1,
              widths: ['10%', '25%', '25%', '25%', '15%'],
              body: allRowsHead
            }
          })
        }
        pdfContent.push({ text: '', style: 'empty_space' })
      }

      /**
       * Institute Info only for Scholarship (Shishu Paribar) 6
       */
       if (data.tracking_no === 6) {
         const instituteInfo = [
          [
            { text: vm.$t('externalUser.institute_info'), colSpan: 4, style: 'th2', alignment: 'center', bold: true },
            {},
            {},
            {}
          ],
          [
            { text: vm.$t('externalUser.institution_name'), style: 'th', alignment: 'left' },
            { text: data.institute_name, style: 'th', alignment: 'left' },
            { text: vm.$t('hospital_public_panel.area_type'), style: 'th', alignment: 'left' },
            { text: data.institute_area_type, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('hospital_public_panel.division'), style: 'th', alignment: 'left' },
            { text: data.institute_division, style: 'th', alignment: 'left' },
            { text: vm.$t('hospital_public_panel.district'), style: 'th', alignment: 'left' },
            { text: data.institute_district, style: 'th', alignment: 'left' }
          ]
         ]

         if (data.institute_area_type_id === 1) {
          instituteInfo.push(
            [
              { text: vm.$t('hospital_public_panel.city_corporation'), style: 'th', alignment: 'left' },
              { text: data.institute_city_corporation, style: 'th', alignment: 'left' },
              { text: vm.$t('hospital_configuration.ward'), style: 'th', alignment: 'left' },
              { text: data.institute_ward, style: 'th', alignment: 'left' }
            ]
          )
        } else if (data.institute_area_type_id === 2) {
          instituteInfo.push(
            [
              { text: vm.$t('hospital_public_panel.upazila'), style: 'th', alignment: 'left' },
              { text: data.institute_upazilla, style: 'th', alignment: 'left' },
              { text: vm.$t('hospital_public_panel.pourashava'), style: 'th', alignment: 'left' },
              { text: data.institute_pauroshoba, style: 'th', alignment: 'left' }
            ],
            [
              { text: vm.$t('hospital_configuration.ward'), style: 'th', alignment: 'left' },
              { text: data.institute_ward, style: 'th', alignment: 'left' },
              {},
              {}
            ]
          )
        } else if (data.institute_area_type_id === 3) {
          instituteInfo.push(
            [
              { text: vm.$t('hospital_public_panel.upazila'), style: 'th', alignment: 'left' },
              { text: data.institute_upazilla, style: 'th', alignment: 'left' },
              { text: vm.$t('hospital_public_panel.union'), style: 'th', alignment: 'left' },
              { text: data.institute_union, style: 'th', alignment: 'left' }
            ],
            [
              { text: vm.$t('hospital_configuration.ward'), style: 'th', alignment: 'left' },
              { text: data.institute_ward, style: 'th', alignment: 'left' },
              {},
              {}
            ]
          )
        }
        pdfContent.push({
          table: {
            headerRows: 0,
            widths: ['25%', '25%', '25%', '25%'],
            body: instituteInfo
          },
          layout: {
            hLineWidth: function (i, node) {
              return 0
            },
            vLineWidth: function (i, node) {
              return 0
            }
          }
        })
        pdfContent.push({ text: '', style: 'empty_space' })
      }

      /**
       * Address
       */
      const address = [
        [
          {
            text: data.tracking_no === 10
              ? vm.$t('externalUser.ucd_development_x_present_address')
              : data.tracking_no === 9
                ? vm.$t('externalUser.offender_correction_address')
                : data.tracking_no === 8
                  ? vm.$t('externalUser.patient_info_and_address')
                  : vm.$t('globalTrans.present_address'),
            colSpan: 4,
            style: 'th2',
            alignment: 'center',
            bold: true
          },
          {},
          {},
          {}
        ]
      ]
      if (data.has_address) {
        address.push(
          [
            { text: vm.$t('hospital_public_panel.area_type'), style: 'th', alignment: 'left' },
            { text: data.address_area_type, style: 'th', alignment: 'left' },
            { text: vm.$t('externalUser.address'), style: 'th', alignment: 'left' },
            { text: data.tracking_no === 8 ? (vm.currentLocale === 'en' ? data.patient_welfare_assoc.address : data.patient_welfare_assoc.address_bn) : (vm.currentLocale === 'en' ? data.address : data.address_bn), style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('org_pro_division.division'), style: 'th', alignment: 'left' },
            { text: data.division, style: 'th', alignment: 'left' },
            { text: vm.$t('org_pro_district.district'), style: 'th', alignment: 'left' },
            { text: data.district, style: 'th', alignment: 'left' }
          ]
        )
        if (data.address_area_type_id === 1) {
          address.push(
            [
              { text: vm.$t('hospital_public_panel.city_corporation'), style: 'th', alignment: 'left' },
              { text: data.address_city_corporation, style: 'th', alignment: 'left' },
              { text: vm.$t('hospital_configuration.ward'), style: 'th', alignment: 'left' },
              { text: data.address_ward, style: 'th', alignment: 'left' }
            ]
          )
        } else if (data.address_area_type_id === 2) {
          address.push(
            [
              { text: vm.$t('hospital_public_panel.upazila'), style: 'th', alignment: 'left' },
              { text: data.address_upazilla, style: 'th', alignment: 'left' },
              { text: vm.$t('hospital_public_panel.pourashava'), style: 'th', alignment: 'left' },
              { text: data.address_pauroshoba, style: 'th', alignment: 'left' }
            ],
            [
              { text: vm.$t('hospital_configuration.ward'), style: 'th', alignment: 'left' },
              { text: data.address_ward, style: 'th', alignment: 'left' },
              {},
              {}
            ]
          )
        } else if (data.address_area_type_id === 3) {
          address.push(
            [
              { text: vm.$t('hospital_public_panel.upazila'), style: 'th', alignment: 'left' },
              { text: data.address_upazilla, style: 'th', alignment: 'left' },
              { text: vm.$t('hospital_public_panel.union'), style: 'th', alignment: 'left' },
              { text: data.address_union, style: 'th', alignment: 'left' }
            ],
            [
              { text: vm.$t('hospital_configuration.ward'), style: 'th', alignment: 'left' },
              { text: data.address_ward, style: 'th', alignment: 'left' },
              {},
              {}
            ]
          )
        }
        pdfContent.push({
          table: {
            headerRows: 0,
            widths: ['25%', '25%', '25%', '25%'],
            body: address
          },
          layout: {
            hLineWidth: function (i, node) {
              return 0
            },
            vLineWidth: function (i, node) {
              return 0
            }
          }
        })

        pdfContent.push({ text: '', style: 'empty_space' })
      }
      /**
       * Beneficiary Account Information
       */
      if (data.beneficiary && data.beneficiary.category_id === 2) {
        pdfContent.push({
          table: {
            headerRows: 0,
            widths: ['25%', '25%', '25%', '25%'],
            body: [
              [
                {
                  text: (
                    data.tracking_no === 11
                      ? vm.$t('externalUser.beneficiary_account_information')
                      : data.tracking_no === 8
                      ? vm.$t('externalUser.pat_association_bank_info')
                      : data.tracking_no === 9
                      ? vm.$t('externalUser.offender_beneficiary_account')
                      : data.tracking_no === 10
                      ? vm.$t('externalUser.council_beneficiary_account')
                      : vm.$t('externalUser.beneficiary_account_information')
                  ),
                  colSpan: 4,
                  style: 'th2',
                  alignment: 'center',
                  bold: true
                },
                {},
                {},
                {}
              ],
              [
                { text: vm.$t('globalTrans.beneficiary_account_type'), style: 'th', alignment: 'left' },
                { text: data.account_type_name, style: 'th', alignment: 'left' },
                { text: vm.$t('globalTrans.account_no'), style: 'th', alignment: 'left' },
                { text: vm.$n(data.beneficiary.account_no, { useGrouping: false }), style: 'th', alignment: 'left' }
              ],
              [
                { text: vm.$t('globalTrans.account_name'), style: 'th', alignment: 'left' },
                { text: vm.currentLocale === 'en' ? data.beneficiary.account_name : data.beneficiary.account_name_bn, style: 'th', alignment: 'left' },
                { text: vm.$t('globalTrans.mfs_service'), style: 'th', alignment: 'left' },
                { text: data.mfs_service, style: 'th', alignment: 'left' }
              ]
            ]
          },
          layout: {
            hLineWidth: function (i, node) {
              return 0
            },
            vLineWidth: function (i, node) {
              return 0
            }
          }
        })
      } else if (data.beneficiary && data.beneficiary.category_id === 1) {
        pdfContent.push({
          table: {
            headerRows: 0,
            widths: ['25%', '25%', '25%', '25%'],
            body: [
              [
                // { text: vm.$t('report.bnswc_dontation'), colSpan: 4, style: 'th2', alignment: 'center', bold: true },
                {
                  text: (
                    data.tracking_no === 11
                      ? vm.$t('externalUser.beneficiary_account_information')
                      : data.tracking_no === 8
                      ? vm.$t('externalUser.pat_association_bank_info')
                      : data.tracking_no === 9
                      ? vm.$t('externalUser.offender_beneficiary_account')
                      : data.tracking_no === 10
                      ? vm.$t('externalUser.council_beneficiary_account')
                      : vm.$t('externalUser.beneficiary_account_information')
                  ),
                  colSpan: 4,
                  style: 'th2',
                  alignment: 'center',
                  bold: true
                },
                {},
                {},
                {}
              ],
              [
                { text: vm.$t('globalTrans.beneficiary_account_type'), style: 'th', alignment: 'left' },
                { text: data.account_type_name, style: 'th', alignment: 'left' },
                { text: vm.$t('globalTrans.account_no'), style: 'th', alignment: 'left' },
                { text: data.beneficiary.account_no, style: 'th', alignment: 'left' }
              ],
              [
                { text: vm.$t('globalTrans.account_name_x'), style: 'th', alignment: 'left' },
                { text: vm.currentLocale === 'en' ? data.beneficiary.account_name : data.beneficiary.account_name_bn, style: 'th', alignment: 'left' },
                { text: vm.$t('globalTrans.account_type'), style: 'th', alignment: 'left' },
                { text: data.bank_account_type, style: 'th', alignment: 'left' }
              ],
              [
                { text: vm.$t('globalTrans.bank_name'), style: 'th', alignment: 'left' },
                { text: vm.currentLocale === 'en' ? data.beneficiary.bank_name : data.beneficiary.bank_name_bn, style: 'th', alignment: 'left' },
                { text: vm.$t('globalTrans.branch_name'), style: 'th', alignment: 'left' },
                { text: vm.currentLocale === 'en' ? data.beneficiary.branch_name : data.beneficiary.branch_name_bn, style: 'th', alignment: 'left' }
              ],
              [
                { text: vm.$t('externalUser.routing_no'), style: 'th', alignment: 'left' },
                { text: data.orphanage ? vm.$n(data.orphanage.routing_no, { useGrouping: false }) : (data.beneficiary.routing_no ? vm.$n(data.beneficiary.routing_no, { useGrouping: false }) : ''), style: 'th', alignment: 'left' },
                { text: data.beneficiary.branch_district_id ? vm.$t('org_pro_district.district') : '', style: 'th', alignment: 'left' },
                { text: data.beneficiary.branch_district_id ? vm.getDistrictName(data.beneficiary.branch_district_id) : '', style: 'th', alignment: 'left' }
              ]
            ]
          },
          layout: {
            hLineWidth: function (i, node) {
              return 0
            },
            vLineWidth: function (i, node) {
              return 0
            }
          }
        })
      } else if (data.scholarship.mfs_service) {
        pdfContent.push({
          table: {
            headerRows: 0,
            widths: ['25%', '25%', '25%', '25%'],
            body: [
              [
                {
                  text: (
                    data.tracking_no === 11
                      ? vm.$t('externalUser.beneficiary_account_information')
                      : data.tracking_no === 8
                      ? vm.$t('externalUser.pat_association_bank_info')
                      : data.tracking_no === 9
                      ? vm.$t('externalUser.offender_beneficiary_account')
                      : data.tracking_no === 10
                      ? vm.$t('externalUser.council_beneficiary_account')
                      : vm.$t('externalUser.beneficiary_account_information')
                  ),
                  colSpan: 4,
                  style: 'th2',
                  alignment: 'center',
                  bold: true
                },
                {},
                {},
                {}
              ],
              [
                { text: vm.$t('globalTrans.mfs_service'), style: 'th', alignment: 'left' },
                { text: vm.getMfsService(data.scholarship.mfs_service), style: 'th', alignment: 'left' },
                { text: vm.$t('globalTrans.account_no') + vm.$t('globalTrans.mobile_no'), style: 'th', alignment: 'left' },
                { text: vm.$n(data.scholarship.mfs_account_no, { useGrouping: false }), style: 'th', alignment: 'left' }
              ]
            ]
          },
          layout: {
            hLineWidth: function (i, node) {
              return 0
            },
            vLineWidth: function (i, node) {
              return 0
            }
          }
        })
      }

      var docDefinition = {
      content: pdfContent,
      pageSize: 'A4',
      pageOrientation: 'landscape',
      styles: {
          th: {
            fontSize: 10,
            margin: [3, 3, 3, 3]
          },
          th2: {
            fillColor: '#dee2e6',
            fontSize: 10,
            margin: [3, 3, 3, 3]
          },
          td: {
            fontSize: 8,
            margin: [3, 3, 3, 3]
          },
          th1: {
            fontSize: 9
          },
          header: {
            margin: [0, 1, 0, 15],
            fontSize: 16,
            alignment: 'center'
          },
          header2: {
            border: 0,
            fontSize: 14,
            margin: [0, 0, 0, 1]
          },
          govt_info: {
            margin: [0, 1, 0, 1],
            fontSize: 18,
            alignment: 'center'
          },
          address2: {
            border: 0,
            fontSize: 12,
            bold: true,
            margin: [0, 0, 0, 5]
          },
          left_logo: {
            borderRadius: 50
          },
          empty_space: {
            margin: [5, 5, 5, 5]
          }
        }
      }
      // pdfMake.createPdf(docDefinition, null, null, null).print() // 'financial-aid-report')
      pdfMake.createPdf(docDefinition, null, null, null).print()
    } catch (error) {
      if (error) {
      }
    }

    // Loading Complete
    vm.modalLoader = false
}

export default {
  exportPdfDetails
}
